import '../filter_view.js.coffee'

Namespace 'Monitoring.Views.SocialContents.Filters'

class Monitoring.Views.SocialContents.Filters.SurveyItemFiltersView extends Backbone.View
  initialize: (@options = {}) ->
    @facet = @options.facet
    @survey = @facet['cem_surveys'][0]
    @searchQuery = @options.searchQuery

  isEmpty: ->
    return true unless @survey.items
    for code, values of @survey.items
      survey_item_filter = new Monitoring.Models.SurveyItemFilter(code, values)
      return false if @_itemShouldBeRendered(survey_item_filter)
    true

  render: ->
    @_renderFieldFilter(code, values) for code, values of @survey.items if @survey.items
    @

  _renderFieldFilter: (code, values) ->
    survey_item_filter = new Monitoring.Models.SurveyItemFilter(code, values)
    return unless @_itemShouldBeRendered(survey_item_filter)
    @$el.append @_surveyItemFilterView(code, values).render().el

  _surveyItemFilterView: (code, values) ->
    new Monitoring.Views.SocialContents.Filters.SurveyItemFilterView(
      $.extend({name: code, values: values, survey: @survey}, @options)
    )

  _itemShouldBeRendered: (survey_item_filter) ->
    survey_item_filter.shouldBeRendered() and not @_fieldFilterIsApplied(survey_item_filter.filter_code())

  _fieldFilterIsApplied: (code) ->
    survey = @_searchQuerySurvey()
    survey?.items and survey.items[code] and survey.items[code].values.length > 0

  _searchQuerySurvey: ->
    _.find(@searchQuery.get('cem_surveys'), (s) => parseInt(s.id) == parseInt(@survey.id))
